import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentcolor",
  d: "M6.429 5H4.15v-.007c.103-.503.304-.98.592-1.404A3.97 3.97 0 0 1 6.47 2.166c.237-.1.485-.178.737-.229a3.99 3.99 0 0 1 1.586 0 3.911 3.911 0 0 1 1.984 1.07l1.112-1.11a5.53 5.53 0 0 0-1.747-1.18A5.44 5.44 0 0 0 9.11.398a5.562 5.562 0 0 0-2.215 0A5.531 5.531 0 0 0 3.44 2.71a5.483 5.483 0 0 0-.828 1.969c-.022.106-.034.214-.05.322H.143l3.143 3.143L6.429 5Zm3.143 1.57h2.277v.006a3.91 3.91 0 0 1-1.653 2.466 3.884 3.884 0 0 1-1.404.59 3.986 3.986 0 0 1-1.585 0 3.894 3.894 0 0 1-1.985-1.07L4.11 9.676a5.526 5.526 0 0 0 1.748 1.178 5.554 5.554 0 0 0 3.247.32A5.524 5.524 0 0 0 12.56 8.86a5.48 5.48 0 0 0 .827-1.967c.021-.106.034-.214.05-.322h2.42l-3.143-3.143-3.142 3.143Z"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "camera-lookup-link__text control-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([{ 'camera-lookup-link_running': _ctx.running }, "camera-lookup-link"]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dispatchClickEvent && _ctx.dispatchClickEvent(...args)), ["prevent"])),
    href: "#"
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass([{ 'camera-lookup-link__icon_running': _ctx.running }, "camera-lookup-link__icon"]),
      fill: "none",
      height: "12",
      width: "16",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_2, 2)),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1)
  ], 2))
}